import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineHeight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLineHeight"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V5.5H2V4ZM12 6.68934L15.3107 10L14.25 11.0607L12 8.81066L9.75 11.0607L8.68934 10L12 6.68934ZM9.75 13.1893L12 15.4393L14.25 13.1893L15.3107 14.25L12 17.5607L8.68934 14.25L9.75 13.1893ZM2 18.5H22V20H2V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineHeight;
